// extracted by mini-css-extract-plugin
export default {"main":"portfolio_container_main__ntN0G","tabs":"portfolio_container_tabs__dxYg0"};